import React from 'react';
import { usePlanogramAutomationContext } from '@/pages/PlanogramAutomation/context/PlanogramAutomation';
import { BarcodeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Minus } from 'lucide-react';

import {
    ProductsContainer,
    ProductsList,
    ProductArea,
    ProductFigureArea,
    ImageWrapper,
    ProductInfoArea,
    ProductInfo,
    BarCodeArea,
    CategoryProduct,
    ProductTitle,
    BackgroundTransparent,
    StoreName,
} from './styles';
import {
    HeaderPlanogramAutomation,
    HeaderPlanogramAutomationArea,
} from '../Header';

export function Products() {
    const { planogramChecked, setPlanogramsChecked } =
        usePlanogramAutomationContext();

    const handleDeleteProduct = (id: number) => {
        const newPlanogramChecked = planogramChecked.filter(
            (planogram) => planogram.id !== id,
        );
        setPlanogramsChecked(newPlanogramChecked);
    };

    return (
        <ProductsContainer>
            <ProductsList>
                <HeaderPlanogramAutomationArea style={{ paddingBottom: 12 }}>
                    <HeaderPlanogramAutomation />
                </HeaderPlanogramAutomationArea>
                {planogramChecked?.map((planogram) => (
                    <ProductArea key={planogram.id}>
                        <ProductFigureArea>
                            <ImageWrapper>
                                <img
                                    src={planogram.product.image_url}
                                    alt={planogram.product.name}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            </ImageWrapper>
                        </ProductFigureArea>

                        <ProductInfoArea>
                            <ProductTitle>
                                {planogram.product.name}
                            </ProductTitle>
                            <StoreName>{planogram.store.name}</StoreName>
                            <ProductInfo>
                                <CategoryProduct>
                                    <span>
                                        {planogram.product?.Category?.name ??
                                            'Categoria não definida'}
                                    </span>
                                </CategoryProduct>
                                <BarCodeArea>
                                    <BarcodeOutlined
                                        style={{
                                            marginRight: 8,
                                            color: '#B0B0B0',
                                        }}
                                    />
                                    <span>
                                        {planogram.product.BarCodes[0]?.code ||
                                            'Nenhum código de barras cadastrado'}
                                    </span>
                                </BarCodeArea>
                            </ProductInfo>
                        </ProductInfoArea>

                        <Button
                            type="link"
                            style={{
                                position: 'absolute',
                                right: 10,
                                top: '35%',
                                zIndex: 9999,
                            }}
                            onClick={() => handleDeleteProduct(planogram.id)}
                        >
                            <Minus color="#31374A" size={20} />
                        </Button>
                    </ProductArea>
                ))}
            </ProductsList>

            {planogramChecked.length >= 4 && <BackgroundTransparent />}
        </ProductsContainer>
    );
}
